import jquery from "jquery";
// Bootstrap 5 only registers jQuery plugins ($.fn.modal, etc.) if window.jQuery
// exists at evaluation time.  This MUST run before bootstrap is loaded.
// The dynamic import() below guarantees that: all static code in this module
// executes to completion before any module in the dynamically-imported tree
// (which includes @kopjra/uikit → bootstrap) is evaluated.
// @ts-expect-error - assigning jQuery to window for Bootstrap/bootbox compatibility
window.jQuery = jquery;
// @ts-expect-error - assigning $ to window for Bootstrap/bootbox compatibility
window.$ = jquery;

import("./index.tsx");

